import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

// material-ui
import withStyles from '@material-ui/core/styles/withStyles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

// components
import DegreeRequirementsList from 'components/DegreeRequirementsList';
import Page from 'components/Page';
import FormDegreeRequirement from 'components/FormDegreeRequirement';

// styles
import styles from './styles';

class WrapperDegreeRequirementsPage extends Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    loading: PropTypes.bool,

    //degreeRequirements
    degreeRequirements: PropTypes.array,
    getDegreeRequirementById: PropTypes.func,
    createDegreeRequirement: PropTypes.func,
    deleteDegreeRequirement: PropTypes.func,
    updateDegreeRequirement: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedDegreeRequirement: undefined,
      formDegreeRequirementOpen: false,
    };
  }

  getStepContent() {
    const { index } = this.state;
    const { degreeRequirements } = this.props;

    switch (index) {
      case 0:
        return (
          <DegreeRequirementsList
            degreeRequirements={degreeRequirements}
            onSelect={(selectedDegreeRequirement) => this.setState({
              selectedDegreeRequirement,
              formDegreeRequirementOpen: true,
            })}
          />
        );
      default:
    }
  }

  render() {
    const {
      classes,
      history,
      loading,
      createDegreeRequirement,
      deleteDegreeRequirement,
      updateDegreeRequirement,
      refresh,
    } = this.props;

    const {
      index,
      selectedDegreeRequirement,
      formDegreeRequirementOpen,
    } = this.state;

    return (
      <Page
        helmet={'DegreeRequirements'}
        loadingMessage={'Loading Document'}
        loading={loading}
        fab={(
          <Fab
            variant="fab"
            color="primary"
            aria-label="Add"
            className={classes.floatingActionButton}
            onClick={() => this.setState({ formDegreeRequirementOpen: true })}
          >
            <AddIcon />
          </Fab>
        )}
        tabs={(
          <Tabs
            value={index}
            onChange={(e, v) => {
              this.setState({ index: v });
              history.push(`?index=${v}`);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
          >
            <Tab
              label="DegreeRequirements"
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
              }}
            />
          </Tabs>
        )}
      >
        {
          this.getStepContent()
        }
        <FormDegreeRequirement
          open={formDegreeRequirementOpen}
          degreeRequirement={selectedDegreeRequirement}
          close={() => {
            this.setState({
              formDegreeRequirementOpen: false,
            });
            setTimeout(() => this.setState({
              selectedDegreeRequirement: undefined,
            }), 200);
          }
          }
          createDegreeRequirement={createDegreeRequirement}
          deleteDegreeRequirement={deleteDegreeRequirement}
          updateDegreeRequirement={updateDegreeRequirement}
          refresh={refresh}
        />
      </Page>
    )
  }
}
export default withStyles(styles)(WrapperDegreeRequirementsPage);

